export const tip1 =
  'https://storage.googleapis.com/empretec-assets/common/onboarding-tip1.png';
export const tip2 =
  'https://storage.googleapis.com/empretec-assets/common/onboarding-tip2.png';
export const tip3 =
  'https://storage.googleapis.com/empretec-assets/common/onboarding-tip3.png';
export const tip4 =
  'https://storage.googleapis.com/empretec-assets/common/onboarding-tip4.png';
export const banner_empretec =
  'https://storage.googleapis.com/empretec-assets/common/banner-empretec.png';
export const ilustration_error =
  'https://storage.googleapis.com/empretec-assets/common/ilustration_error.png';
export const ilustration_error_resp =
  'https://storage.googleapis.com/empretec-assets/common/ilustration_error_resp.png';
export const ilustration_success =
  'https://storage.googleapis.com/empretec-assets/common/ilustration_success.png';
export const ilustration_success_resp =
  'https://storage.googleapis.com/empretec-assets/common/ilustration_success_resp.png';
export const empretec_actor =
  'https://storage.googleapis.com/empretec-assets/common/empretec-actor.png';
export const empretec_graphics =
  'https://storage.googleapis.com/empretec-assets/common/empretec-graphics.png';
export const empretec_candidate_text =
  'https://storage.googleapis.com/empretec-assets/common/empretec-candidate-text.png';
export const empretec_actor_without_interview =
  'https://storage.googleapis.com/empretec-assets/urban/empretec-urban-candidate-actor.png';
export const empretec_graphics_withtou_interview =
  'https://storage.googleapis.com/empretec-assets/urban/empretec-urban-graphics.png';
export const empretec_candidate_text_without_interview =
  'https://storage.googleapis.com/empretec-assets/urban/empretec-urban-candidate-text.png';
